import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/25-2_commentslash.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const CommentSlash: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default CommentSlash;
